/**
 * CNC Back-in-Stock — NATIVE (RFC-EMAIL-001 C7). Replaces the direct-to-Klaviyo path.
 * Subscribes to Dawn's pubsub 'variant-change'; shows the notify-me form when the selected variant
 * is unavailable, hides the ATC button + sticky ATC bar in the same state. POSTs to OUR email-signup
 * endpoint (event:'back_in_stock' + variant_id) — stored in email_bis_request with a back_in_stock
 * consent; fn_email_bis_notify_cron_fire emails the shopper when the variant is available again.
 *
 * Rules (from live notes): listen only. Never intercept variant-change. Never preventDefault on the picker.
 */
(function () {
  'use strict';

  function init() {
    var bis = document.querySelector('[data-cnc-bis]');
    if (!bis) return;
    var prompt = bis.querySelector('[data-cnc-bis-prompt]');
    var emailBox = bis.querySelector('[data-cnc-bis-email]');
    var confirmed = bis.querySelector('[data-cnc-bis-confirmed]');
    var trigger = bis.querySelector('[data-cnc-bis-trigger]');
    var input = bis.querySelector('[data-cnc-bis-input]');
    var submit = bis.querySelector('[data-cnc-bis-submit]');
    var errorEl = bis.querySelector('[data-cnc-bis-error]');

    var ENDPOINT = bis.getAttribute('data-cnc-endpoint') ||
                   'https://dkzndqkjjzhmmcebqoib.supabase.co/functions/v1/email-signup';
    var COUNTRY = (bis.getAttribute('data-country') || 'US').toUpperCase();
    var PRODUCT_TITLE = (trigger && trigger.getAttribute('data-product-title')) || null;

    var atcWrapper = document.querySelector('.cnc-pdp .product-form__buttons')
                  || document.querySelector('product-form');
    var stickyAtc = document.querySelector('.cnc-satc, [data-cnc-satc]');
    var currentVariantId = null;

    function isSubscribed(id) { try { return sessionStorage.getItem('cnc_bis_' + id) === '1'; } catch (e) { return false; } }
    function markSubscribed(id) { try { sessionStorage.setItem('cnc_bis_' + id, '1'); } catch (e) {} }

    function showState(state) {
      bis.style.display = state ? '' : 'none';
      prompt.style.display = state === 'prompt' ? '' : 'none';
      emailBox.style.display = state === 'email' ? '' : 'none';
      confirmed.style.display = state === 'confirmed' ? '' : 'none';
      if (errorEl) errorEl.style.display = 'none';
      var hideAtc = !!state;
      if (atcWrapper) atcWrapper.style.display = hideAtc ? 'none' : '';
      if (stickyAtc) stickyAtc.style.display = hideAtc ? 'none' : '';
    }
    function showNotifyMe(id) {
      currentVariantId = id;
      trigger.setAttribute('data-variant-id', id);
      if (isSubscribed(id)) { showState('confirmed'); return; }
      showState('prompt');
    }
    function hideNotifyMe() { showState(null); }
    function showEmailField() { showState('email'); if (input) { input.value = ''; input.focus(); } }
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.style.display = ''; }
    function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

    function submitBIS(email, variantId) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: 'back_in_stock',
          email: email,
          country: COUNTRY,
          variant_id: String(variantId),
          product_title: PRODUCT_TITLE,
          source: 'pdp_notify_me',
          form_url: location.href
        })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok && d && d.subscribed) {
            markSubscribed(variantId);
            showState('confirmed');
            return true;
          }
          showError("Something went sideways. Try again in a moment.");
          return false;
        });
      }).catch(function () {
        showError("Something went sideways. Try again in a moment.");
        return false;
      });
    }

    /* Dawn variant-change (pubsub). Payload: {data:{variant:{available,id,...}}} */
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function (e) {
        var v = e && e.data && e.data.variant;
        if (!v) return;
        if (v.available === false) { showNotifyMe(v.id); } else { hideNotifyMe(); }
      });
    }

    /* Initial page-load: if the default variant is sold out, render the form. */
    var defaultVariantInput = document.querySelector('.cnc-pdp input[name="id"], .cnc-pdp select[name="id"]');
    if (defaultVariantInput) {
      var initialId = defaultVariantInput.value;
      var submitBtn = document.querySelector('.cnc-pdp .product-form__submit');
      if (initialId && submitBtn && (submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true')) {
        var soldOutLabel = submitBtn.querySelector('.sold-out-message');
        var btnText = (submitBtn.textContent || '').toLowerCase();
        if ((soldOutLabel && !soldOutLabel.classList.contains('hidden')) || btnText.indexOf('sold out') !== -1) {
          showNotifyMe(initialId);
        }
      }
    }

    /* Notify-me button -> ask for the email (no Klaviyo cookie prefill anymore). */
    if (trigger) {
      trigger.addEventListener('click', function () { showEmailField(); });
    }

    /* Email submit */
    if (submit && input) {
      submit.addEventListener('click', function () {
        var email = (input.value || '').trim();
        var id = trigger.getAttribute('data-variant-id') || currentVariantId;
        if (!isValidEmail(email)) { showError('Please enter a valid email'); return; }
        if (errorEl) errorEl.style.display = 'none';
        submit.disabled = true;
        submitBIS(email, id).then(function () { submit.disabled = false; });
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
